import { reportTypes } from '../reduxExports'

const chargersHistoryReportInitialState: ReportState = {
    chargingHistoryColumnHeaders: null,
    chargingHistoryData: null,
    chargingHistoryFiltersAppliedFromRedirection:false,
    chargingHistoryCount: 0,
    reportLoader: false,
    chargerLogsCount: 0,
    chargerLogsColumnHeaders: null,
    chargerLogsData: null,
    exceptionLogsCount: 0,
    exceptionLogsColumnHeaders: null,
    exceptionLogsData: null,
    chargingHistoryListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    chargerLogsListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    exceptionLogsListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    chargerLogsFiltersRequestHash: null,
    sessionHistoryColumnHeaders: null,
    sessionHistoryData: null,
    sessionHistoryFiltersAppliedFromRedirection: false,
    sessionHistoryCount: 0,
    sessionHistoryListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    sessionHistoryFiltersRequestHash: null,
    sessionHistorySearchHash: null,
    statusHistoryColumnHeaders: null,
    statusHistoryData: null,
    statusHistoryCount: 0,
    statusHistoryListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    statusHistoryFiltersRequestHash: null,
    statusHistorySearchHash: null,
    statusHistoryFiltersAppliedFromRedirection: false,
    stopReasonEnumsEnabled: null,
    stopReasonEnumsApplicable: null,
    inventoryParamHistoryData: null,
    inventoryParamHistoryColumns: null,
    inventoryParamHistoryTableProps: {
        view: 'list',
        sortBy: 'loggedAt',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    inventoryParamHistoryRequestSearchHash: null,
    inventoryParamHistoryRequestFilterHash: null,
    inventoryParamHistoryLoader: false,
    inventoryParamLatestLogsData: null,
    inventoryParamLatestLogsColumns: null,
    inventoryParamLatestLogsDataCount: 0,
    inventoryParamLatestLogsDataRequestSearchHash: null,
    inventoryParamLatestLogsDataRequestFilterHash: null, 
    inventoryParamLatestLogsTableProps: {
        view: 'list',
        sortBy: 'loggedAt',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    inventoryParamChangeLogsData: null,
    inventoryParamChangeLogsColumns: null,
    inventoryParamChangeLogsDataRequestSearchHash: null,
    inventoryParamChangeLogsDataRequestFilterHash: null, 
    inventoryParamChangeLogsTableProps: {
        view: 'list',
        sortBy: 'loggedAt',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    } 
}

const reportsReducer = (state: ReportState = chargersHistoryReportInitialState, action: ReportAction): ReportState => {
    switch (action.type) {
        case reportTypes.FETCH_CHARGERS_HISTORY_DATA:
            return {
                ...state,
                chargingHistoryColumnHeaders: action.chargingHistoryColumnHeaders,
                chargingHistoryData: action.chargingHistoryData,
                chargingHistoryCount: action.chargingHistoryCount
            }
        case reportTypes.SET_REPORT_LOADER:
            return {
                ...state,
                reportLoader: action.reportLoader
            }
        case reportTypes.SET_CHARGING_HISTORY_LIST_TABLE_PROPS:
            return {
                ...state,
                chargingHistoryListTableProps: action.chargingHistoryListTableProps
            }
        case reportTypes.CLEAR_CHARGING_HISTORY_LIST_DATA:
            return {
                ...state,
                chargingHistoryColumnHeaders: null,
                chargingHistoryData: null,
                chargingHistoryCount: 0,
                reportLoader: false,
                chargingHistoryListTableProps: {
                    view: 'list',
                    sortBy: state.chargingHistoryListTableProps?.sortBy || '',
                    order: state.chargingHistoryListTableProps?.order || 'ascending',
                    pageSize: state.chargingHistoryListTableProps?.pageSize || 15,
                    pageNumber: state.chargingHistoryListTableProps?.pageNumber || 1,
                    searchTerm: ''
                }
            }
        case reportTypes.FETCH_CHARGER_LOGS_DATA:
            return {
                ...state,
                chargerLogsColumnHeaders: action.chargerLogsColumnHeaders,
                chargerLogsData: action.chargerLogsData,
                chargerLogsCount: action.chargerLogsCount
            }
        case reportTypes.SET_CHARGER_LOGS_LIST_TABLE_PROPS:
            return {
                ...state,
                chargerLogsListTableProps: action.chargerLogsListTableProps
            }
        case reportTypes.CLEAR_CHARGER_LOGS_LIST_DATA:
            return {
                ...state,
                chargerLogsColumnHeaders: null,
                chargerLogsData: null,
                chargerLogsCount: 0,
                reportLoader: false,
                chargerLogsListTableProps: {
                    view: 'list',
                    sortBy: '',
                    order: 'ascending',
                    pageSize: state.chargerLogsListTableProps?.pageSize || 15,
                    pageNumber: state.chargerLogsListTableProps?.pageNumber || 1,
                    searchTerm: ''
                }
            }
        case reportTypes.FETCH_EXCEPTION_LOGS_DATA:
            return {
                ...state,
                exceptionLogsColumnHeaders: action.exceptionLogsColumnHeaders,
                exceptionLogsData: action.exceptionLogsData,
                exceptionLogsCount: action.exceptionLogsCount
            }
        case reportTypes.SET_EXCEPTION_LOGS_LIST_TABLE_PROPS:
            return {
                ...state,
                exceptionLogsListTableProps: action.exceptionLogsListTableProps
            }
        case reportTypes.CLEAR_EXCEPTION_LOGS_LIST_DATA:
            return {
                ...state,
                exceptionLogsColumnHeaders: null,
                exceptionLogsData: null,
                exceptionLogsCount: 0,
                reportLoader: false,
                exceptionLogsListTableProps: {
                    view: 'list',
                    sortBy: '',
                    order: 'ascending',
                    pageSize: state.exceptionLogsListTableProps?.pageSize || 15,
                    pageNumber: state.exceptionLogsListTableProps?.pageNumber || 1,
                    searchTerm: ''
                }
            }
        case reportTypes.SET_CHARGER_LOGS_LIST_REQUEST_HASH:
            return {
                ...state,
                chargerLogsFiltersRequestHash: action.chargerLogsFiltersRequestHash
            }
        case reportTypes.SET_CHARGING_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION:
            return{
                ...state,
                chargingHistoryFiltersAppliedFromRedirection:action.chargingHistoryFiltersAppliedFromRedirection || false
            }
        case reportTypes.FETCH_SESSION_HISTORY_DATA:
            return {
                ...state,
                sessionHistoryColumnHeaders: action.sessionHistoryColumnHeaders,
                sessionHistoryData: action.sessionHistoryData,
                sessionHistoryCount: action.sessionHistoryCount,
            }
        case reportTypes.SET_SESSION_HISTORY_LIST_TABLE_PROPS:
            return {
                ...state,
                sessionHistoryListTableProps: action.sessionHistoryListTableProps
            }
        case reportTypes.CLEAR_SESSION_HISTORY_LIST_DATA:
            return {
                ...state,
                sessionHistoryColumnHeaders: null,
                sessionHistoryData: null,
                sessionHistoryCount: 0,
                sessionHistoryListTableProps: {
                    view: 'list',
                    sortBy: '',
                    order: 'ascending',
                    pageSize: 15,
                    pageNumber: 1,
                    searchTerm: ''
                },
                reportLoader: false,
            }
        case reportTypes.SET_SESSION_HISTORY_LIST_REQUEST_HASH:
            return {
                ...state,
                sessionHistoryFiltersRequestHash: action.sessionHistoryFiltersRequestHash,
                sessionHistorySearchHash: action.sessionHistorySearchHash
            }
        case reportTypes.SET_SESSION_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION:
            return{
                ...state,
                sessionHistoryFiltersAppliedFromRedirection:action.sessionHistoryFiltersAppliedFromRedirection || false
            }
        case reportTypes.FETCH_STATUS_HISTORY_DATA:
            return {
                ...state,
                statusHistoryColumnHeaders: action.statusHistoryColumnHeaders,
                statusHistoryData: action.statusHistoryData,
                statusHistoryCount: action.statusHistoryCount ?? 0,
            }
        case reportTypes.SET_STATUS_HISTORY_LIST_REQUEST_HASH:
            return {
                ...state,
                statusHistoryFiltersRequestHash: action.statusHistoryFiltersRequestHash,
                statusHistorySearchHash: action.statusHistorySearchHash
            }
        case reportTypes.SET_STATUS_HISTORY_LIST_TABLE_PROPS:
            return {
                ...state,
                statusHistoryListTableProps: action.statusHistoryListTableProps
            }
        case reportTypes.SET_STATUS_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION: 
            return {
                ...state,
                statusHistoryFiltersAppliedFromRedirection: action.statusHistoryFiltersAppliedFromRedirection|| false
            }
        case reportTypes.CLEAR_STATUS_HISTORY_LIST_DATA:
            return {
                ...state,
                statusHistoryColumnHeaders: null,
                statusHistoryData: null,
                statusHistoryCount: 0,
                statusHistoryListTableProps: {
                    view: 'list',
                    sortBy: '',
                    order: 'ascending',
                    pageSize: 15,
                    pageNumber: 1,
                    searchTerm: ''
                },
                reportLoader: false,
            }
        case reportTypes.FETCH_STOP_REASON_ENUMS_ENABLED:
            return {
                ...state,
                stopReasonEnumsEnabled: action.stopReasonEnumsEnabled,
            }
        case reportTypes.FETCH_STOP_REASON_ENUMS_APPLICABLE:
            return {
                ...state,
                stopReasonEnumsApplicable: action.stopReasonEnumsApplicable,
            }
        case reportTypes.FETCH_INVENTORY_PARAM_HISTORY_REPORT_DATA:
            return {
                ...state,
                inventoryParamHistoryData: action.inventoryParamHistoryData,
                inventoryParamHistoryColumns: action.inventoryParamHistoryColumns
            }
        case reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER:
            return {
                ...state,
                inventoryParamHistoryLoader: action.inventoryParamHistoryLoader
            }
        case reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_REQUEST_HASH:
            return {
                ...state,
                inventoryParamHistoryRequestSearchHash: action.inventoryParamHistoryRequestSearchHash,
                inventoryParamHistoryRequestFilterHash: action.inventoryParamHistoryRequestFilterHash
            }
        case reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_TABLE_PROPS:
            return {
                ...state,
                inventoryParamHistoryTableProps: action.inventoryParamHistoryTableProps
            }
        case reportTypes.FETCH_INVENTORY_PARAM_LATEST_LOGS_REPORT_DATA:
            return {
                ...state,
                inventoryParamLatestLogsData: action.inventoryParamLatestLogsData,
                inventoryParamLatestLogsDataCount: action.inventoryParamLatestLogsDataCount,
                inventoryParamLatestLogsColumns: action.inventoryParamLatestLogsColumns
            }
        case reportTypes.SET_INVENTORY_PARAM_LATEST_LOGS_REPORT_REQUEST_HASH:
            return {
                ...state,
                inventoryParamLatestLogsDataRequestSearchHash: action.inventoryParamLatestLogsDataRequestSearchHash,
                inventoryParamLatestLogsDataRequestFilterHash: action.inventoryParamLatestLogsDataRequestFilterHash
            }
        case reportTypes.SET_INVENTORY_PARAM_LATEST_LOGS_REPORT_TABLE_PROPS:
            return {
                ...state,
                inventoryParamLatestLogsTableProps: action.inventoryParamLatestLogsTableProps
            }
        case reportTypes.FETCH_INVENTORY_PARAM_CHANGE_LOGS_REPORT_DATA:
            return {
                ...state,
                inventoryParamChangeLogsData: action.inventoryParamChangeLogsData,
                inventoryParamChangeLogsColumns: action.inventoryParamChangeLogsColumns
            }
        case reportTypes.SET_INVENTORY_PARAM_CHANGE_LOGS_REPORT_REQUEST_HASH:
            return {
                ...state,
                inventoryParamChangeLogsDataRequestSearchHash: action.inventoryParamChangeLogsDataRequestSearchHash,
                inventoryParamChangeLogsDataRequestFilterHash: action.inventoryParamChangeLogsDataRequestFilterHash
            }
        case reportTypes.SET_INVENTORY_PARAM_CHANGE_LOGS_REPORT_TABLE_PROPS:
            return {
                ...state,
                inventoryParamChangeLogsTableProps: action.inventoryParamChangeLogsTableProps
            }
        case reportTypes.CLEAR_INVENTORY_PARAM_HISTORY_REPORT_DATA:
            return {
                ...state,
                inventoryParamHistoryData: null,
                inventoryParamHistoryColumns: null,
                inventoryParamHistoryTableProps: {
                    view: 'list',
                    sortBy: 'loggedAt',
                    order: 'descending',
                    pageSize: 15,
                    pageNumber: 1,
                    searchTerm: ''
                },
                inventoryParamHistoryRequestSearchHash: null,
                inventoryParamHistoryRequestFilterHash: null,
                inventoryParamHistoryLoader: false,
                inventoryParamLatestLogsData: null,
                inventoryParamLatestLogsColumns: null,
                inventoryParamLatestLogsDataCount: 0,
                inventoryParamLatestLogsDataRequestSearchHash: null,
                inventoryParamLatestLogsDataRequestFilterHash: null, 
                inventoryParamLatestLogsTableProps: {
                    view: 'list',
                    sortBy: 'loggedAt',
                    order: 'descending',
                    pageSize: 15,
                    pageNumber: 1,
                    searchTerm: ''
                },
                inventoryParamChangeLogsData: null,
                inventoryParamChangeLogsColumns: null,
                inventoryParamChangeLogsDataRequestSearchHash: null,
                inventoryParamChangeLogsDataRequestFilterHash: null, 
                inventoryParamChangeLogsTableProps: {
                    view: 'list',
                    sortBy: 'loggedAt',
                    order: 'descending',
                    pageSize: 15,
                    pageNumber: 1,
                    searchTerm: '' 
                }
            }
        default:
            return state
    }
}

export default reportsReducer